import React, { Component } from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import {setChannelList} from '../../actions';

import {Api, Time} from '../../util';

import File from './File';
import {Error} from '../../components/modal';

import Loading from '../../components/loading';

let TIMER;
class ContentContainer extends Component {
  constructor(props){
  super(props);
    this.state={
      total: [],
      channelList:[],
      errorContent: {},
      loadingToggle: false,
      toggleText: '자세한 정보 열기',
      toggleClass: 'modal-content',
      showModal: false,
      showError: false
    }
    this.handleHide = this.handleHide.bind(this);
  }
  handleHide() {
    this.setState({showModal: false});
  }

  componentWillReceiveProps (nextProps) {
    if(this.props.selectedDate !== nextProps.selectedDate){
      this.getEpgInfo(nextProps.selectedDate);  
    }
  }

  componentWillMount(){
    this.getEpgInfo();  
  }

  async getEpgInfo(date = Time.getAddDate(Time.getToday(), -1)){
    this.setState({
      loadingToggle: true
    });
    try{
      await this.chListArray(date);
      this.setState({
        showError: false
      });
    }catch(e){
      // NOTE: 파일이 없는 경우는 오류창을 띄우지 않는다.
      if(e.detail && !e.detail.includes('There is no broadcast file.')) {
        console.error(e);
        this.setState({
          showModal: true,
          errorContent: e
        });
      }
      this.setState({showError: true})

    } finally {
      this.setState({
        loadingToggle: false
      });
    }
  }

  async chListArray(date){
    const chInfo = (await Api.GetChList()).files;
    const channelList = chInfo.ch
      .filter(ch => ch.use === 'Y')
      .map(ch => {
        const resolvedObj = {};
        // NOTE: epg 객체처럼 property 이름을 모두 소문자로 바꾼다
        _.keys(ch).forEach(propName => {
          resolvedObj[propName.toLowerCase()] = ch[propName];
        })
        return resolvedObj;
      });

    const vodArray = channelList.map(async element => {
      const vodInfo = (await Api.SearchVodFile({chName: element.chname, date})).files.file;
      return vodInfo;
    });

    return new Promise((resolve, reject) => {
      Promise.all(vodArray)
        .then((value)=>{
          const numberOfVodList = value.length;
          if(numberOfVodList === 0){ // 모든 채널정보가 없을 경우 데이터 없는 페이지 보여준다
            this.setState({
              showError: true,
              loadingToggle: false
            })
          }else{
            this.props.setChannelList(channelList);
            this.setState({
              total: value
            }, () => {
              resolve();
            });
          }
        });
    });
     
  }


  render() {
    const {
      loadingToggle,
      total,
      channelList,
      showModal,
      errorContent,
      showError,
    } = this.state;

    const {
      selectedMenu
    } = this.props;

    return (
      <div className='content'>
        {loadingToggle ? <Loading /> : null }
        <File total={total} showError={showError} />
        {showModal ? <Error 
          handleHide={this.handleHide}
          errorContent={errorContent}
        /> : null}
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    selectedDate: state.selectedDate,
    selectedMenu: state.selectedMenu
  }
};
const mapDispatcherToProps = dispatch => {
  return {
    setChannelList: (channelList) => dispatch(setChannelList(channelList))
  }
};

ContentContainer = connect(mapStateToProps, mapDispatcherToProps)(ContentContainer);

export default ContentContainer;



// WEBPACK FOOTER //
// ./src/containers/file/ContentContainer.js